var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":'累计换电里程'}}),_c('Chart',{attrs:{"cdata":_vm.cdata,"height":_vm.height,"width":_vm.width}}),_c('div',{staticClass:"text-center color-white"},[_vm._v("km")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }